import React from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import './index.scss'

import RightRecommendItem from '../../../components/VideoDetail/RightRecommendItem'

export default () => {
    const { videoRelatedList } = useSelector((state) => ({
        videoRelatedList: state.video.videoRelatedList
    }), shallowEqual)

    return (
        <div className="video-detail-right-recommend">
            <div className="video-detail-right-recommend-title-box">
                <div className="video-detail-right-recommend-line"></div>
                <div className="video-detail-right-recommend-title">相关视频</div>
            </div>
            {videoRelatedList.map((item) => {
                return (
                    <RightRecommendItem {...item} key={item.id} />
                )
            })}
        </div>
    )
}
